import { render, staticRenderFns } from "./CustomItem.vue?vue&type=template&id=83194e86&"
import script from "./CustomItem.vue?vue&type=script&lang=ts&"
export * from "./CustomItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports